import i18n from '../services/language.service'
const { t } = i18n

export const fontProperties = [
  {
    label: " --font-size-10",
    value: 10,
    unit: "px",
  },
  {
    label: "--font-size-11",
    value: 11,
    unit: "px",
  },
  {
    label: "--font-size-12",
    value: 12,
    unit: "px",
  },
  {
    label: "--font-size-12",
    value: 13,
    unit: "px",
  },
  {
    label: "--font-size-14",
    value: 14,
    unit: "px",
  },
  {
    label: "--font-size-15",
    value: 15,
    unit: "px",
  },
  {
    label: "--font-size-16",
    value: 16,
    unit: "px",
  },
  {
    label: "--font-size-18",
    value: 18,
    unit: "px",
  },
  {
    label: "--font-size-21",
    value: 21,
    unit: "px",
  },
  {
    label: "--font-size-24",
    value: 24,
    unit: "px",
  },
  {
    label: "--font-size-26",
    value: 26,
    unit: "px",
  },
  {
    label: "--font-size-28",
    value: 28,
    unit: "px",
  },
  {
    label: "--font-size-35",
    value: 35,
    unit: "px",
  },
  {
    label: "--font-size-36",
    value: 36,
    unit: "px",
  },
  {
    label: "--font-size-40",
    value: 40,
    unit: "px",
  },
  {
    label: "--font-size-45",
    value: 45,
    unit: "px",
  },
  {
    label: "--font-size-50",
    value: 50,
    unit: "px",
  },
  {
    label: "--font-size-220",
    value: 220,
    unit: "px",
  }
];

export const magnifiers = () => [
  {
    label: t('EDIT_THEME.NORMAL'),
    value: 1,
  },
  {
    label: t('EDIT_THEME.LARGER'),
    value: 1.125,
  },
  {
    label: t('EDIT_THEME.LARGE'),
    value: 1.25,
  },
];
